import { render, staticRenderFns } from "./SettingsSalary.vue?vue&type=template&id=c4d4e20e&scoped=true&"
import script from "./SettingsSalary.vue?vue&type=script&lang=js&"
export * from "./SettingsSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d4e20e",
  null
  
)

export default component.exports